module.exports = __webpack_public_path__ + "img/icon-settings.1c81ad49.svg";